import { selectUserSettingsValue } from "~/state/user/selectors";
import { ESETTINGS_KEYS } from "~/state/user/interfaces";
import { store } from "~/state/store";
import Scene from "~/scene";
import { isSaturationMapset } from "~/util/mapset";

const dimmLayer = Scene.createLayerMarker();

export function setDimmLayer(show = false, shadowLayer = false) {
	if (selectUserSettingsValue(store.getState(), ESETTINGS_KEYS.SEARCH_MAP_SUPPRESSION) && show) {
		Scene.addLayer(dimmLayer, true);

		dimmLayer.getShadowContainer(cont => {
			if (cont) {
				cont.classList[shadowLayer ? "add" : "remove"]("tile-dimm-layer");
			}
		});
		dimmLayer.getContainer(cont => {
			if (cont) {
				cont.classList[shadowLayer ? "remove" : "add"]("tile-dimm-layer");
			}
		});
	} else {
		Scene.removeLayer(dimmLayer);
	}
}

export function setSaturation(on = false) {
	const state = store.getState().map;

	selectUserSettingsValue(store.getState(), ESETTINGS_KEYS.SEARCH_MAP_SUPPRESSION) && isSaturationMapset(state) && Mapy.getComponent("layout").setClassOnMapElement("saturation", !on);
}
